export const Location = (data) => ({
  type: "GET_LOC",
  playload: data,
});

export const CurrentCar = (data) => ({
  type: "GET_CAR",
  playload: data,
});

export const CurrentBranch = (data) => ({
  type: "GET_BRANCH",
  playload: data,
});

export const CurrentLoc = (data) => ({
  type: "CUR_LOC",
  playload: data,
});

export const LocPermission = (data) => ({
  type: "LOC_PER",
  playload: data,
});

export const SignInStatus = (data) => ({
  type: "GET_SIGNIN",
  playload: data,
});

export const LastNumber = (data) => ({
  type: "GET_NUMBER",
  playload: data,
});

export const LastURL = (data) => ({
  type: "GET_URL",
  playload: data,
});
